module.exports = __webpack_public_path__ + "static/media/7C.768d16ac.svg";